<template>
    <div class="c-product-variation-line c-product-line" v-if="hasPrice">
        <strong class="u-color-alpha-base">{{ product.Name }}</strong>

        <div class="grid">
            <div class="c-product-color">
                <v-gallery :images="variationImage"></v-gallery>
            </div>

            <div>
                <div v-if="group.Brand">
                    <strong class="u-semi-bold">{{ $t('product.thumb.brand') }}:</strong>
                    {{ group.Brand }}
                </div>
                <div v-if="group.BrandSubgroup">
                    <strong class="u-semi-bold">{{ $t('product.thumb.category') }}:</strong>
                    {{ group.BrandSubgroup }}
                </div>
                <div v-if="group.Type">
                    <strong class="u-semi-bold">{{ $t('product.thumb.segment') }}:</strong>
                    {{ group.Type }}
                </div>

            </div>

            <div>
                <div v-if="product.Color">
                    <strong class="u-semi-bold">Kleur:</strong>{{ product.ColorId }} {{ product.Color }}
                </div>
                <v-input v-if="isEditableField" @change="updateProduct" v-model.number="product.PreOrderDiscount" input-size="tiny" :max="MaximumDiscount" :min=0 type="number" width="50px" :name="`${_uid}_variation_pre_order_discount`" :disabled="isDisabled">
                    <slot slot="label"><strong>{{ $t('product.thumb.preOrder_discount') }}:</strong></slot>
                    <slot slot="suffix">({{ $t('product.thumb.max') }} {{ product.MaximumDiscount }}%)</slot>
                </v-input>
            </div>

            <div>
                <table class="c-product-info u-pull-right u-margin-right-medium">
                    <tr>
                        <td><strong class="u-semi-bold">{{ $t('product.thumb.price') }}:</strong></td>
                        <td>{{ product.RetailFromPrice | currency(customerCurrencySymbol) }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="c-product-seperator">
        </div>
        <div class="c-product-variation-line-bottom o-gutter-large">
            <div class="c-product-select-sizes u-margin-bottom-small">
                <v-marketing-product-size-input v-for="item in productSizes" :key="item.Id" :item.sync="item" :readOnly="readOnly"></v-marketing-product-size-input>
            </div>
            <div class="u-flex-set u-flex--wrap o-spacing">
                <div>
                    <strong>{{ $t('product.line.total_amount') }}:</strong>
                    <span>{{ TotalAmount }}</span>
                </div>
                <div>
                    <strong>{{ $t('product.line.total_price') }}:</strong>
                    <span>{{ TotalPrice | currency(customerCurrencySymbol)}}</span>
                </div>
                <div v-if="!isEditableField">
                    <strong>{{ $t('product.line.discount') }}:</strong>
                    <span>{{product.PreOrderDiscount}}%</span>
                </div>
                <div>
                    <strong>{{ $t('product.line.netto_price') }}:</strong>
                    <span>{{ NettoPrice | currency(customerCurrencySymbol) }}</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import debounce from 'lodash/debounce'
    import VSelect from '@/components/form/Select'
    import VInput from '@/components/form/Input'
    import VGallery from '@/components/gallery/Gallery'
    import VMarketingProductSizeInput from '@/components/product/widgets/marketingProductSizeInput'

    export default {
        props: {
            product: Object,
            parentId: String,
            group: Object,
            groupIndex: Number,
            isEditableField: { type: Boolean },
            readOnly: {type: Boolean, default: false}
        },
        components: {
            VSelect,
            VInput,
            VGallery,
            VMarketingProductSizeInput
        },
        data() {
            return {
                productSizes: this.product.Variants,
                updateProduct: debounce(function () {
                  this.$store.dispatch('updatePreOrderMarketingProduct', {
                    preOrderId: this.$route.params.id,
                    productId: this.product.Id,
                    body: {
                      Id: this.product.Id,
                      PreOrderDiscount: this.product.PreOrderDiscount
                    }
                  }).then(() => {
                    this.$store.dispatch('getPreOrderById', this.$route.params.id);
                  });
                }, 500)
            }
        },
        computed: {
            /**
             * @return {number}
             */
            TotalAmount() {
              let amountArray = this.productSizes.map(result => result.Amount);
              return amountArray.reduce((a, b) => a + b);
            },
            /**
             * @return {number}
             */
            TotalPrice() {
              return this.TotalAmount * this.product.RetailFromPrice;
            },
            /**
             * @return {number}
             */
            NettoPrice() {
              return this.TotalPrice * ((100 - this.product.PreOrderDiscount) / 100)
            },
            variationImage() {
                let output = !this.product.Images.length ? null : [];
                if (this.product.Images.length) {
                    output = this.product.Images[0].replace('[WIDTH]', 60).replace('[HEIGHT]', 60);
                }
                return output;
            },
            isDisabled() {
                return this.product.IsDeleted || this.readOnly;
            },
            MaximumDiscount() {
                let discount;
                if (this.product.MaximumDiscount) {
                    discount = this.product.MaximumDiscount;
                } else {
                    discount = 0;
                }
                return discount;
            },
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            },
            hasPrice(){
                return this.product.RetailFromPrice >= 0;
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-product-variation-line {
        border-color: $color-info;


        &.isDisabled {
            opacity:.5;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/product/common/MarketingVariationLine.vue